module.exports = __webpack_public_path__ + "img/zn4.085bbe7e.png";